import { Component, inject } from '@angular/core';

import { AuthService } from '../data-access/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-auth-redirect-to',
  imports: [],
  standalone: true,
  templateUrl: './redirect-to.component.html',
  styleUrl: './redirect-to.component.css',
})
export class RedirectToComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  constructor() {
    const isAuth = this.auth.isAuthenticated();
    this.router.navigate([isAuth ? '/' : '/login']).then((r) => r);
  }
}
